import useTranslation from "next-translate/useTranslation"
import Link from "next/link"
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap"

import TranslatedHtml from "@components/common/TranslatedHtml"
import { Routes } from "@services/routes"

import ReportProjectForm from "./ReportProjectForm"

interface IProps {
  modalOpen: boolean
  isIdea: boolean // different translations for ideas & projects
  onSubmit: (...args: any) => void
  toggle: () => void
}

/**
 * provides a modal to report a misuse of a project
 */
const ReportProjectModal: React.FC<IProps> = (props: IProps) => {
  const { modalOpen, isIdea, onSubmit, toggle } = props
  const { t } = useTranslation("common")

  return <Modal isOpen={modalOpen} toggle={toggle}>
    <ModalHeader>
      {t("page.projects.index.reportProjectHeading")}
    </ModalHeader>
    <ModalBody>
      <p>
        {isIdea ? <TranslatedHtml content="page.projects.index.reportIdeaIntro" />
          : <TranslatedHtml content="page.projects.index.reportProjectIntro" />
        }
      </p>
      <ReportProjectForm onSubmit={onSubmit} toggle={toggle} />
    </ModalBody>
    <ModalFooter>
      <Link href={Routes.DataProtection}>
        <a>{t("goto.dataProtection")}</a>
      </Link>
    </ModalFooter>
  </Modal>
}

export default ReportProjectModal
